module.exports = __webpack_public_path__ + "img/gcivil-logo.png";